import { z } from 'zod';
import { InterestSlug, MAX_INTERESTS } from './interests';

export const FakeUserCreateInput = z.object({
  firstName: z.string().min(1).max(64),
  lastName: z.string().min(1).max(64).optional(),
  cityId: z.uuid(),
  bio: z.string().max(280).optional(),
  birthDate: z.iso.date().optional(),
  interests: z.array(InterestSlug).max(MAX_INTERESTS),
  isDiscoverable: z.boolean().optional(),
});
export type FakeUserCreateInput = z.infer<typeof FakeUserCreateInput>;

export const FakeUserUpdateInput = z.object({
  firstName: z.string().min(1).max(64).optional(),
  lastName: z.string().min(1).max(64).nullable().optional(),
  cityId: z.uuid().optional(),
  bio: z.string().max(280).nullable().optional(),
  birthDate: z.iso.date().nullable().optional(),
  interests: z.array(InterestSlug).max(MAX_INTERESTS).optional(),
  isDiscoverable: z.boolean().optional(),
});
export type FakeUserUpdateInput = z.infer<typeof FakeUserUpdateInput>;

export const FakeUserListQuery = z.object({
  cityId: z.uuid().optional(),
  discoverable: z
    .union([z.boolean(), z.enum(['true', 'false'])])
    .transform((v) => (typeof v === 'boolean' ? v : v === 'true'))
    .optional(),
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(100).default(20),
});
export type FakeUserListQuery = z.infer<typeof FakeUserListQuery>;

export const FakeUserDto = z.object({
  id: z.uuid(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  cityId: z.uuid().nullable(),
  bio: z.string().nullable(),
  birthDate: z.iso.date().nullable(),
  isDiscoverable: z.boolean(),
  photoUrl: z.string().nullable(),
  interests: z.array(InterestSlug),
  createdAt: z.iso.datetime(),
});
export type FakeUserDto = z.infer<typeof FakeUserDto>;

export const FakeUserListResponse = z.object({
  items: z.array(FakeUserDto),
  nextCursor: z.string().nullable(),
});
export type FakeUserListResponse = z.infer<typeof FakeUserListResponse>;
